// A narrow desktop window is still a desktop, so this reads the device rather
// than the viewport.
export const getMobileOS = (): 'android' | 'ios' | undefined => {
  if (typeof navigator === 'undefined' || typeof document === 'undefined')
    return undefined
  const ua = navigator.userAgent
  if (/android/i.test(ua)) {
    return 'android'
  }
  // An iPad reports itself as a Mac, so touch support is the only thing left to go on.
  if (
    /iPad|iPhone|iPod/.test(ua) ||
    (ua.includes('Macintosh') && 'ontouchend' in document)
  ) {
    return 'ios'
  }
  return undefined
}
